import React from "react";
import { a } from "react-router-dom";
import "./footer.css";
import { BRAND_NAME, FOOTER_LOGO, IMAGE_PATH } from "../../Utils/variables";

const Footer = () => {
  const d = new Date();
  let year = d.getFullYear();

  console.log(window.scrollTo);
  return (
    <div className="footerMainDiv">
      <div className="footerMainDivTop">
        <div className="footerColumns">
          <img
            src={FOOTER_LOGO}
            alt={`${BRAND_NAME} logo`}
            className="footerlogo"
          />
          <p id="anacityDesc">
            The ANACITY services suite leverages Next-Gen technology to
            significantly enhance the residential experience in gated
            communities.
          </p>
        </div>
        <div className="footerColumns">
          <div className="footerSubHeading">Quick Links</div>
          <p>
            <a href={process.env.REACT_APP_ANACITY_URL + "/"}>Home</a>
          </p>
          <p>
            <a href={process.env.REACT_APP_ANACITY_URL + "/about-us"}>About</a>
          </p>
          <p>
            <a href={process.env.REACT_APP_ANACITY_URL + "/services"}>
              Services
            </a>
          </p>
          <p>
            <a
              href={process.env.REACT_APP_ANACITY_URL + "/contact-us-for-demo"}
            >
              Contact Us
            </a>
          </p>
          <p>
            <a href={process.env.REACT_APP_ANACITY_URL + "/privacy-policy"}>
              Privacy Policy
            </a>
          </p>{" "}
          <p>
            <a href={process.env.REACT_APP_ANACITY_URL + "/terms-of-service"}>
              Terms of Service
            </a>
          </p>
        </div>
        <div className="footerColumns">
          <div className={"footerSubHeading"}>Services</div>
          <p>
            <a
              href={
                process.env.REACT_APP_ANACITY_URL + "/multi-property-dashboard"
              }
            >
              Multi-Property Dashboard
            </a>
          </p>
          <p>
            <a
              href={
                process.env.REACT_APP_ANACITY_URL +
                "/community-accounting-software"
              }
            >
              Financial Management
            </a>
          </p>
          <p>
            <a href={process.env.REACT_APP_ANACITY_URL + "/gatekeeper"}>
              Gate Management
            </a>
          </p>
          <p>
            <a
              href={process.env.REACT_APP_ANACITY_URL + "/facility-mgmt-tools"}
            >
              Facility Management
            </a>
          </p>
          <p>
            <a href={process.env.REACT_APP_ANACITY_URL + "/community-helpdesk"}>
              Community Help Desk
            </a>
          </p>
          <p>
            <a
              href={
                process.env.REACT_APP_ANACITY_URL +
                "/community-collaboration-tools"
              }
            >
              Communication
            </a>
          </p>
        </div>
        <div className="lastColumInFooter">
          <div className="footerSubHeading ">Be Social, Be Connected</div>
          <div className="multiLogoDiv">
            <a href="https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2Fanacitybyanarock">
              <img src={IMAGE_PATH + "fb.png"} alt="fb" />
            </a>
            <a href="https://twitter.com/anacityofficial">
              <img src={IMAGE_PATH + "twitter.png"} alt="twitter" />
            </a>
            <a href="https://www.linkedin.com/company/anacity">
              <img src={IMAGE_PATH + "linkdin.png"} alt="linkdin" />
            </a>
            <a href="https://www.instagram.com/anacitybyanarock/">
              <img src={IMAGE_PATH + "insta.png"} alt="instagram" />
            </a>
            <a href="https://www.youtube.com/channel/UCAi_QAsUY6qfTRLvz3hWfuw">
              <img src={IMAGE_PATH + "yt.png"} alt="youtube" />
            </a>
          </div>
          <p id="corporateOffice">Corporate Office</p>
          <p>702, Empire Heights Tower B, Business Bay - Dubai, UAE</p>
          <div className="footerContact">
            <i class="fa-solid fa-envelope mr-2"></i>
            <a href="mailto:sales@anacity.com">sales@anacity.com</a>
          </div>
          <div className="footerContact">
            <i class="fa-solid fa-phone mr-2"> </i>
            <a href="tel:+97145656184">+971-45656184</a>
          </div>
        </div>
      </div>
      <div className="copyRight">
        {" "}
        <div className="footerMainDivBottom">
          © Copyright 2010 - {year && year}. ANAROCK Group Business Services
          Pvt. Ltd. All rights reserved.
        </div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Footer;
